export default "__VITE_ASSET__44bRj4G8__"